import Heading from 'components/Basic/Heading/Heading';
import Link from 'components/Basic/Link/Link';
import { useTypedTranslationFunction } from 'hooks/typescript/UseTypedTranslationFunction';
import { FileIcon } from 'public/svg/IconsSvg';
import { ProductFileType } from 'types/file';

type ProductFilesProps = {
    files: ProductFileType[];
};

const ProductFiles: FC<ProductFilesProps> = (props) => {
    const testIdentifier = 'pages-productdetail-files';
    const t = useTypedTranslationFunction();

    if (props.files.length === 0) {
        return null;
    }

    const getFileNameByType = ({ type, anchorText }: ProductFileType): string => {
        return type === 'ManualFile'
            ? t('Product file manual')
            : type === 'RecipeFile'
            ? t('Product file recipe')
            : type === 'ManualRecipeFile'
            ? t('Product file manual recipe')
            : anchorText;
    };

    return (
        <div className="vl:flex" data-testid={testIdentifier}>
            <Heading type="h2" className="hidden basis-1/5 vl:block">
                {t('Product manuals')}
            </Heading>
            <ul className="basis-4/5 pb-10 vl:pb-0">
                {props.files.map((file) => (
                    <li key={file.url}>
                        <Link
                            className="pb-2 text-body font-bold text-red vl:py-2 vl:px-0"
                            href={file.urlToOpen}
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            <>
                                <FileIcon className="text-red" />
                                {getFileNameByType(file)}
                            </>
                        </Link>
                    </li>
                ))}
            </ul>
        </div>
    );
};

export default ProductFiles;
